/**
 * @generated SignedSource<<9062d478904466813eaf35c7c0296fe5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type OrderLoyaltyRewardStatus = "AVAILABLE" | "REQUIRES_ORDER_ITEM" | "UNAVAILABLE";
export type OrderStatus = "CANCELED" | "DRAFT" | "EMPTY" | "FULLY_PAID" | "FULLY_REFUNDED" | "OPEN" | "PARTIALLY_PAID" | "PARTIALLY_REFUNDED";
export type SquareLoyaltyRewardStatus = "DELETED" | "ISSUED" | "REDEEMED";
import { FragmentRefs } from "relay-runtime";
export type PatronCheckoutLoyaltyRewards_order$data = {
  readonly availableLoyaltyRewards: {
    readonly balance: number;
    readonly rewardTiers: ReadonlyArray<{
      readonly rewardTier: {
        readonly id: string;
        readonly name: string;
        readonly points: number;
      };
      readonly status: OrderLoyaltyRewardStatus;
    }>;
    readonly terminologyOne: string;
    readonly terminologyOther: string;
  } | null | undefined;
  readonly bookings: ReadonlyArray<{
    readonly id: string;
    readonly totalDueAfterCredits: number | null | undefined;
  } | null | undefined> | null | undefined;
  readonly expectedLoyaltyPoints: number | null | undefined;
  readonly id: string;
  readonly orderOwner: {
    readonly club: {
      readonly timeZone: string;
    };
    readonly squareLoyaltyAccount: {
      readonly expiringPointDeadlines: ReadonlyArray<{
        readonly expiresAt: string;
        readonly id: string;
        readonly points: number;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly squareLoyaltyRewards: ReadonlyArray<{
    readonly id: string;
    readonly loyaltyAccount: {
      readonly id: string;
    } | null | undefined;
    readonly loyaltyCustomerId: string | null | undefined;
    readonly points: number;
    readonly rewardTier: {
      readonly id: string;
      readonly name: string;
    };
    readonly status: SquareLoyaltyRewardStatus;
  }>;
  readonly status: OrderStatus | null | undefined;
  readonly total: number | null | undefined;
  readonly totalDiscount: number | null | undefined;
  readonly totalTaxes: number | null | undefined;
  readonly " $fragmentType": "PatronCheckoutLoyaltyRewards_order";
};
export type PatronCheckoutLoyaltyRewards_order$key = {
  readonly " $data"?: PatronCheckoutLoyaltyRewards_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"PatronCheckoutLoyaltyRewards_order">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PatronCheckoutLoyaltyRewards_order",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalTaxes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalDiscount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "bookings",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalDueAfterCredits",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expectedLoyaltyPoints",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "orderOwner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareLoyaltyAccount",
          "kind": "LinkedField",
          "name": "squareLoyaltyAccount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareLoyaltyAccountExpiringPointDeadline",
              "kind": "LinkedField",
              "name": "expiringPointDeadlines",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expiresAt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Club",
          "kind": "LinkedField",
          "name": "club",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timeZone",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderAvailableLoyaltyRewards",
      "kind": "LinkedField",
      "name": "availableLoyaltyRewards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "balance",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "terminologyOne",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "terminologyOther",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderLoyaltyRewardTier",
          "kind": "LinkedField",
          "name": "rewardTiers",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareLoyaltyRewardTier",
              "kind": "LinkedField",
              "name": "rewardTier",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v3/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareLoyaltyReward",
      "kind": "LinkedField",
      "name": "squareLoyaltyRewards",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "loyaltyCustomerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareLoyaltyAccount",
          "kind": "LinkedField",
          "name": "loyaltyAccount",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareLoyaltyRewardTier",
          "kind": "LinkedField",
          "name": "rewardTier",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};
})();

(node as any).hash = "4dce25788ff76f114e2acc91a7844540";

export default node;
